import { EMPTY_OBJECT } from '../../../../../constants/common'

export function getApiProps({ objectId, page }) {
  return {
    object_id: objectId,
    page,
  }
}

export function getDataPagination(data) {
  return data
    ? {
        count: data.meta.count,
        page: data.meta.curr_page,
        pageCount: data.meta.page_count,
        pageSize: data.meta.limit,
      }
    : EMPTY_OBJECT
}

export function getItemsFromResponse(data) {
  return { count: data?.meta?.count, items: data?.results?.objects }
}
